module.exports = __webpack_public_path__ + "assets/img/prev_date.cd760707.svg";